import { render } from "./HomeMenuGuest.vue?vue&type=template&id=0b157728&scoped=true"
import script from "./HomeMenuGuest.vue?vue&type=script&lang=js"
export * from "./HomeMenuGuest.vue?vue&type=script&lang=js"

import "./HomeMenuGuest.vue?vue&type=style&index=0&id=0b157728&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b157728"

export default script